// extracted by mini-css-extract-plugin
export var cardHeader = "_fz-1";
export var contentCard = "_fz-0";
export var headerActions = "_fz-3";
export var reorderHandle = "_fz-5";
export var titleArea = "_fz-2";
export var titleAreaWithHandle = "_fz-4";